import React, { useState } from 'react'
import {Button,Modal,Table} from 'react-bootstrap'

const style = {
    'button': {
        'width': '137px',
        'height': '40px',
        'background-image': 'linear-gradient(to right, #00c6fb 0%, #005bea 100%)',
        'color': '#ffffff',
        'font-family': 'Karla, sans-serif',
        'font-size': '16px',
        'font-weight': '400',
        'letter-spacing': '-1px'
    }
}

function ModalTop50 () {
    
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const top50Teams = [
        {
          "teamName": "Sukasuka",
          "cityOfOrigin": "Bandung"
        },
        {
          "teamName": "Kojor",
          "cityOfOrigin": "Bandung"
        },
        {
          "teamName": "Qoolqas",
          "cityOfOrigin": "Purwokerto"
        },
        {
          "teamName": "Ga Chibi",
          "cityOfOrigin": "Bandung"
        },
        {
          "teamName": "Never Logout",
          "cityOfOrigin": "Yogyakarta"
        },
        {
          "teamName": "Bismillah Team",
          "cityOfOrigin": "Purwokerto"
        },
        {
          "teamName": "Tech Warrior",
          "cityOfOrigin": "Surabaya"
        },
        {
          "teamName": "Rotics",
          "cityOfOrigin": "Riau"
        },
        {
          "teamName": "LigaFunMahasiswa",
          "cityOfOrigin": "Bandung"
        },
        {
          "teamName": "HeyIO",
          "cityOfOrigin": "Tangerang"
        },
        {
          "teamName": "Griya360",
          "cityOfOrigin": "Denpasar"
        },
        {
          "teamName": "Bettfu",
          "cityOfOrigin": "Surabaya"
        },
        {
          "teamName": "Sibayau-bayau",
          "cityOfOrigin": "Bandung"
        },
        {
          "teamName": "Vulcan",
          "cityOfOrigin": "Bandung"
        },
        {
          "teamName": "Automosen-1",
          "cityOfOrigin": "Bandung"
        },
        {
          "teamName": "Isathon",
          "cityOfOrigin": "Bandung"
        },
        {
          "teamName": "Gama Squad",
          "cityOfOrigin": "Yogyakarta"
        },
        {
          "teamName": "Simbah Ganteng",
          "cityOfOrigin": "Purwokerto"
        },
        {
          "teamName": "Furgetech",
          "cityOfOrigin": "Padang"
        },
        {
          "teamName": "Dkletz",
          "cityOfOrigin": "Bandung"
        },
        {
          "teamName": "Cyclops",
          "cityOfOrigin": "Bandung"
        },
        {
          "teamName": "Wiin-R",
          "cityOfOrigin": "Jakarta"
        },
        {
          "teamName": "Global Medika",
          "cityOfOrigin": "Bandung"
        },
        {
          "teamName": "Anak Kuli",
          "cityOfOrigin": "Banyumas"
        },
        {
          "teamName": "Xynergy",
          "cityOfOrigin": "Bandung"
        },
        {
          "teamName": "Neotek",
          "cityOfOrigin": "Jakarta"
        },
        {
          "teamName": "YAF",
          "cityOfOrigin": "Jakarta"
        },
        {
          "teamName": "PP Genius",
          "cityOfOrigin": "Surabaya"
        },
        {
          "teamName": "Stark",
          "cityOfOrigin": "Surabaya"
        },
        {
          "teamName": "Life Saver harness",
          "cityOfOrigin": "Surabaya"
        },
        {
          "teamName": "EZ4ENCE",
          "cityOfOrigin": "Yogyakarta"
        },
        {
          "teamName": "Safety Fast",
          "cityOfOrigin": "Yogyakarta"
        },
        {
          "teamName": "MK AI",
          "cityOfOrigin": "Depok"
        },
        {
          "teamName": "Holy Code",
          "cityOfOrigin": "Yogyakarta"
        },
        {
          "teamName": "Volantis",
          "cityOfOrigin": "Jakarta"
        },
        {
          "teamName": "Skynet",
          "cityOfOrigin": "Bandung"
        },
        {
          "teamName": "Chicken Little",
          "cityOfOrigin": "Bandung"
        },
        {
          "teamName": "Free Tshirt",
          "cityOfOrigin": "Jakarta"
        },
        {
          "teamName": "OSAD",
          "cityOfOrigin": "Jakarta"
        },
        {
          "teamName": "Hakuy",
          "cityOfOrigin": "Jakarta"
        },
        {
          "teamName": "DOSCOM",
          "cityOfOrigin": "Semarang"
        },
        {
          "teamName": "miniBig",
          "cityOfOrigin": "Surabaya"
        },
        {
          "teamName": "Vivat Si",
          "cityOfOrigin": "Surabaya"
        },
        {
          "teamName": "Ruya",
          "cityOfOrigin": "Bandung"
        },
        {
          "teamName": "sooyaaa_",
          "cityOfOrigin": "Bandung"
        },
        {
          "teamName": "AgriReality ",
          "cityOfOrigin": "Jakarta"
        },
        {
          "teamName": "Logicon",
          "cityOfOrigin": "Jakarta"
        },
        {
          "teamName": "Nyoba Dulu",
          "cityOfOrigin": "Jakarta"
        },
        {
          "teamName": "AI & Friends",
          "cityOfOrigin": "Jakarta"
        },
        {
          "teamName": "Dhani",
          "cityOfOrigin": "Bekasi"
        }
      ];

    const tableOfTop50 = () => {
        const teams = [];
        top50Teams.map((team)=>{
            teams.push(
                <tr>
                    <td>{team.teamName}</td>
                    <td>{team.cityOfOrigin}</td>
                </tr>
            )
        });
        return teams;
    };

    return (
        <div>
            <Button variant="primary" onClick={handleShow} style={style.button}>
                Click me!
            </Button>
            {/* <a href="/" className="btn btn-link right-icon" >Learn more <i className="icon icon-minimal-right"></i></a> */}
    
            <Modal size="lg" centered show={show} onHide={handleClose} animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Qualified Teams</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                            <th>Team Name</th>
                            <th>City of Origin</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableOfTop50()}
                        </tbody>
                    </Table>
                </Modal.Body>
            </Modal>
        </div>
    );
}


export default ModalTop50
